const compareStringsWithPoints = (a: string, b: string) => {
  if (a === b) {
    return 0;
  }
  const aArr = a.split(".");
  const bArr = b.split(".");
  for (let i = 0; i < Math.min(aArr.length, bArr.length); i++) {
    if (aArr[i] < bArr[i]) {
      return -1;
    }
    if (aArr[i] > bArr[i]) {
      return 1;
    }
  }
  if (aArr.length < bArr.length) {
    return -1;
  }
  if (aArr.length > bArr.length) {
    return 1;
  }
  return 0;
};

export default compareStringsWithPoints;
